import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getYearList = store => store[NAME].yearList;
export const getPerformanceProcessList = store => store[NAME].performanceProcessList;
export const getCalibrationCommitteeList = store => store[NAME].calibrationCommitteeList;
export const getData = store => store[NAME].data;
export const getFilterOptions = store => store[NAME].filterOptions;
export const getFormData = store => store[NAME].formData;
export const getGraphicsData = store => store[NAME].graphicsData;